// extracted by css-extract-rspack-plugin
var _1 = "fkfD6VdNgbc3XxMp";
var _2 = "SAMOKdek84nfdDPB";
var _3 = "SAMOKdek84nfdDPB";
export { _1 as "box", _2 as "navigation-wrapper", _3 as "navigationWrapper" }
